import { render, staticRenderFns } from "./ApprovalsDashboard.vue?vue&type=template&id=01d7d934&scoped=true&"
import script from "./ApprovalsDashboard.vue?vue&type=script&lang=js&"
export * from "./ApprovalsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalsDashboard.vue?vue&type=style&index=0&id=01d7d934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d7d934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d7d934')) {
      api.createRecord('01d7d934', component.options)
    } else {
      api.reload('01d7d934', component.options)
    }
    module.hot.accept("./ApprovalsDashboard.vue?vue&type=template&id=01d7d934&scoped=true&", function () {
      api.rerender('01d7d934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/dashboard/ApprovalsDashboard.vue"
export default component.exports